<template>
  <div>
    <div class="home d-flex">
      <div class="intro-text d-flex align-items-end px-md-5">
        <div class="position-relative">
          <h1 v-html="$t('Návrh interiéru zadarmo <br>a zľava na nábytok na mieru')"></h1>
          <p class="mb-4">{{ $t('Klienti projektu Bory Bývanie môžu získať interiérový návrh od spoločnosti Nario zadarmo a zároveň využiť atraktívnu zľavu na nákup nábytku.') }}</p>
        </div>
      </div>
    </div>

    <section class="section-3 free-offer p-3">
      <div class="">
        <div class="row px-3">
          <div class="col-md-5 p-0 px-md-5 py-5 pb-custom">
            <h2 class="mb-4">{{ $t('Návrh interiéru zadarmo') }}</h2>
            <p class="mb-5" v-html="$t('Prispôsobte svoj nový domov vašim predstavám a využite možnosť získať návrh interiéru zadarmo. <br>Ponuku môžu využiť všetci klienti projektu Bory Bývanie.')"></p>
            <p>{{ $t('Prečítajte si') }} <a href="../../docs/Podmienky_akcie_Zlava_na_zariadenie_interieru.pdf" class="font-weight-bold text-white" target="_blank" style="text-decoration: underline;">{{ $t('Všeobecné obchodné podmienky akcie') }}.</a></p>
          </div>
          <div class="col-md-7 bg-img"></div>
        </div>
      </div>
    </section>

    <section class="section-3 dark-bg p-3">
      <div class="">
        <div class="row px-3">
          <div class="col-md-7 bg-img-2"></div>
          <div class="col-md-5 p-0 px-md-5 py-5 pb-custom-2">
            <h2 class="mb-4" v-html="$t('Zľava na nábytok na&nbsp;mieru')"></h2>
            <p class="mb-5">{{ $t('Pri nákupe nábytku od spoločnosti Nario môžete využiť zľavu, ktorej výška závisí od typu a celkovej hodnoty vybraných produktov.') }}</p>
            <b-button @click="scrollTo('zlavy')" class="d-block d-md-inline-block px-5" squared variant="primary">{{ $t('Pozrieť ponuku zliav') }}</b-button>
          </div>
        </div>
      </div>
    </section>

    <div class="catalog" id="zlavy">
      <div class="container">
        <div id="catalog-slider">
          <h2>{{ $t('Ponuka zliav') }}</h2>
          <div class="row mb-5">
            <div class="slide col-12 col-md-4">
              <div class="position-relative">
                <img src="../assets/images/nabytok/01.jpg" alt="">
                <div class="info">
                  <div class="discount-text">{{ $t('Zľava 1 000 €') }}</div>
                  <p v-html="$t('Na sedačky LIDEN')"></p>
                </div>
              </div>
            </div>
            <div class="slide col-12 col-md-4">
              <div class="position-relative">
                <img src="../assets/images/nabytok/04A.jpg" alt="">
                <div class="info">
                  <div class="discount-text">{{ $t('Zľava 2 000 €') }}</div>
                  <p v-html="$t('Na všetok sortiment pri nákupe v hodnote 15&nbsp;000 € - 25&nbsp;000 €.<br><br>')"></p>
                </div>
              </div>
            </div>
            <div class="slide col-12 col-md-4">
              <div class="position-relative">
                <img src="../assets/images/nabytok/03.jpg" alt="">
                <div class="info">
                  <div class="discount-text">{{$t('Zľava 3 000 €')}}</div>
                  <p v-html="$t('Na všetok sortiment pri nákupe v hodnote nad 25&nbsp;000 €.<br><br>')"></p>
                </div>
              </div>
            </div>
          </div>
          
          <p class="text-center">{{ $t('Viac podrobností o akcii nájdete vo') }} <a href="../../docs/Podmienky_akcie_Zlava_na_zariadenie_interieru.pdf" target="_blank">{{ $t('Všeobecných obchodných podmienkach') }}</a>.</p>
        </div>
      </div>
    </div>

    <section class="section-3 free-offer p-3">
      <div class="">
        <div class="row px-3">
          <div class="col-md-5 p-0 px-md-5 py-5 pb-custom">
            <h2 class="mb-4">Nario</h2>
            <p class="mb-5" v-html="$t('Spoločnosť Nario ponúka komplexné riešenia pre váš interiér – od vlastnej stolárskej výroby nábytku na mieru, cez&nbsp;tapety, čalúnené zásteny, závesy a&nbsp;záclony, až po svietidlá, čalúnené postele, matrace, žalúzie a tieniacu techniku.')"></p>
          </div>
          <div class="col-md-7 bg-img-3"></div>
        </div>
      </div>
    </section>

    <ContactForm></ContactForm>
  </div>
</template>

<script>
import ScrollTo from "@/utils/scrollTo.util";
import ContactForm from "@/components/shared/ContactForm";

export default {
  name: "Nabytok",
  components: {ContactForm},
  data() {
    return {
      slickOptions: {
        infinite: false,
        adaptiveHeight: true,
        dots: true,
        arrows: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        // Any other options that can be got from plugin documentation
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      },
    }
  },
  methods: {
    scrollTo(id) {
      const map = document.getElementById(id)
      map.scrollIntoView({behavior: "smooth", block: 'start'})

    },
  },
  mounted () {
    ScrollTo.hash(this,  () => window.scrollTo(0, 0))
  }
}
</script>

<style lang="sass" scoped>
$md: 768px
.about-bottom-2
  .bg
    background: url(../assets/images/bory3/bottom-image.jpg) center/cover no-repeat
.about-bottom
  .right-img
    background: url(../assets/images/cam_bedroom_01.jpg) center/cover no-repeat


.catalog
  background: var(--darkBlue)
  padding: 80px 0

  #catalog-slider
    overflow: hidden

  h2
    font-size: 48px
    padding-left: 8px
    margin-bottom: 80px

  .slide
    position: relative

    .info
      position: absolute
      padding: 50px 20px 20px
      bottom: 0
      left: 0
      width: 100%
      background: linear-gradient(to top, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0))
      color: #fff

      .discount-text
        font-size: 34px
        font-weight: 500
        margin-bottom: 10px

    .type
      position: absolute
      left: 0
      bottom: 0
      background: var(--blue)
      padding: 8px 30px
      font-size: 20px
      color: var(--dark)

.section-3
  background: var(--grey)
  color: #fff
  text-align: left

  .pb-custom
    padding-bottom: 50px !important

    @media (max-width: $md)
      padding-bottom: 30px !important

    &-2
      padding-bottom: 130px !important
      @media (max-width: $md)
        padding-bottom: 30px !important

  &.dark-bg
    background: var(--text-dark)

  &.free-offer
    .bg-img
      background: url(../assets/images/nabytok/cam_livingroom_02.jpg) center/cover no-repeat
  .bg-img
    background: url("../assets/images/Bory_Promenada-3.jpg") center/cover no-repeat
    @media (max-width: $md)
      height: 40vh
      background-size: cover
  .bg-img-2
    background: url(../assets/images/nabytok/cam_bedroom_01.jpg) center/cover no-repeat
    @media (max-width: $md)
      height: 40vh
      background-size: cover
  .bg-img-3
    background: url("../assets/images/nabytok/story_info_bh4a.jpg") center/cover no-repeat
    @media (max-width: $md)
      height: 40vh
      background-size: cover
  
  h2
    font-size: 55px
    line-height: 60px
    font-weight: 300
    margin-bottom: 20px
    @media (max-width: $md)
      font-size: 28px
      line-height: 40px
      letter-spacing: -1px
      margin-bottom: 15px
  p
    max-width: 360px
    font-weight: 500
    &:last-child
      margin-bottom: 120px
      @media (max-width: $md)
        margin-bottom: 0
  .bg-col
    height: 800px
    @media (max-width: $md)
      height: 60vh
      margin-bottom: 16px
      padding: 30px
    h3
      font-size: 28px
      line-height: 32px
      font-weight: 400
      margin-bottom: 20px
    p
      font-size: 16px
      line-height: 21px
      font-weight: 500
      @media (max-width: $md)
        font-size: 12px
        line-height: 16px
        max-width: 100%
  .bg-col-1
    background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/bory3/bory3.jpg") center/cover no-repeat
  .bg-col-2
    background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/Bory_Promenada-1.jpg") bottom/cover no-repeat
  .bg-col-3
    background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/bory3/bory3-ihriska.jpg") center/cover no-repeat
    background-position: -350px center
    @media (max-width: $md)
      background-position: center
  .col-md-4
    padding-left: 8px
    padding-right: 8px
.home
  background: linear-gradient(to top, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0)), url("/standards/nadvorie/slide-1.jpg") bottom/cover no-repeat
  p
    margin-bottom: 30px
    max-width: 770px

    &.disclaimer
      font-size: 14px
      font-weight: bold
      font-style: italic

  .badge-offer
    position: absolute
    top: -220px
    right: -220px
    width: 240px

    @media (max-width: $md)
      top: -70%
      left: 50%
      transform: translateX(-50%)
      max-width: 160px

.district
  background: var(--darkBlue)
  img
    width: 100%
.top
  h2
    font-weight: 300
    font-size: 55px
    line-height: 60px
    letter-spacing: -3px
    @media (max-width: $md)
      font-size: 40px
      line-height: 40px
      letter-spacing: -2px
  p
    font-weight: 500
    max-width: 415px
</style>
